module.exports = __webpack_public_path__ + "static/media/DK4055_10.cb750356.jpg";